import * as React from 'react';
import {connect} from 'react-redux';
import '../css/SuperUserPageView.css';
import { Route } from 'react-router-dom';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {ICreateProductState, IProduct } from "../../../infrastructure/interfaces";
import CreateProductModal from "../../Modals/CreateProductModal/CreateProductModal";
import PreviewProductModal from "../../Modals/PreviewProductModal/PreviewProductModal";
import { FilterMenu } from '../../FilterMenu'

export interface IProductTableProps {
  productList: [any];
  onDeleteProduct(product: IProduct): void;
  onToggleProductPublish(product: IProduct, published: boolean): void;
  saveProduct(originalName: string,
              product: IProduct,
              imagesFormData?: FormData,
              logoFormData?: FormData): void;
  createProductState: ICreateProductState;
}

export interface IProductTableState {
    showEditModal: boolean;
    showPreviewModal: boolean;
    editingProduct: IProduct | null;
    previewingProduct: IProduct | null;
    productsFilter: string;
    typesFilter: string;
    categoryFilter: string;
    publishedFilter: string;
    categories:string[];
}

const mapDispatchToProps = (dispatch: any) => {
  return {
  };
};

const mapStateToProps = (state: any) => {
  return {
      productList: state.productList,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProductsTable extends React.Component<IProductTableProps, IProductTableState> {
  shouldUpdate = false;
  tableRow: HTMLElement;
  constructor(props: IProductTableProps) {
    super(props);

    const categoryArray = props.productList.map((p) => {
      return p.category;
    });
    const uniqueCategories = categoryArray.filter(function(item, pos){
      return categoryArray.indexOf(item)== pos; 
    });

    this.state = {
      showEditModal: false,
      showPreviewModal: false,
      editingProduct: null,
      previewingProduct: null,
      productsFilter: '',
      typesFilter: '',
      categoryFilter: '',
      publishedFilter: '',
      categories: uniqueCategories,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    this.shouldUpdate = true;
  }


  onEditProduct = (product: IProduct) => {
      this.shouldUpdate = true;
      this.setState({
          editingProduct: product,
          showEditModal: true,
      });
  };

  onPreviewProduct = (product: IProduct) => {
    this.shouldUpdate = true;
    this.setState({
        previewingProduct: product,
        showPreviewModal: true,
    });
};

  filterProducts = (products: any[]) => {

    const productsFilter = this.state.productsFilter.toUpperCase();

    var filteredProducts = products.filter(p => productsFilter
      ? p.name.toUpperCase().indexOf(productsFilter) > -1
      : true);

    const typesFilter = this.state.typesFilter.toUpperCase();

    if (typesFilter.length > 0) {
      filteredProducts = filteredProducts.filter(p => (p.type.toUpperCase() == "BROCHURE" && typesFilter == "QUAD FOLD") ||  (p.type.toUpperCase() == typesFilter));
    }

    const categoryFilter = this.state.categoryFilter.toUpperCase();
    if (categoryFilter.length > 0) {
      filteredProducts = filteredProducts.filter(p => p.category.toUpperCase() == categoryFilter);
    }

    const publishedFilter = this.state.publishedFilter.toUpperCase();
    if (publishedFilter.length > 0) {
      let showPublished = (publishedFilter == "PUBLISHED");
      filteredProducts = filteredProducts.filter(p => p.published == showPublished);
    }

    return filteredProducts;
  }

  onSearchFilterChange = (e: any) => {
    this.setState({
      productsFilter: e.target.value,
    });
    e.keyCode === 8 && !e.target.value ? this.shouldUpdate = true : this.shouldUpdate = false;
  }

  shouldComponentUpdate(currentProps: any, currentState: any) {
    return (!!currentState.productsFilter || this.shouldUpdate);
  }

  render() {
    const {
      productList,
    } = this.props;
    const filteredProducts = this.filterProducts(productList);

    const {
        showEditModal,
        showPreviewModal,
        categories,
    } = this.state;

    if (showEditModal) {
        return (
            <CreateProductModal
                show={this.state.showEditModal}
                onClose={() => this.setState({showEditModal: false})}
                product={this.state.editingProduct}
                isEditingExistingProduct={true}
                saveProduct={this.props.saveProduct}
                createProductState={this.props.createProductState}
                productType={this.state.editingProduct ? this.state.editingProduct.type : "Brochure"}
            />
        );
    }

    if (showPreviewModal && this.state.previewingProduct) {
      return (
          <PreviewProductModal
              show={this.state.showPreviewModal}
              product={this.state.previewingProduct}
              onClose={() => this.setState({showPreviewModal: false})}
          />
      );
  }

    return (
      <div className="inner-su-container">
        <div className="manage-items-row">

          <div className="productTable-search">
            <input
              type="text"
              onKeyUp={this.onSearchFilterChange}
              placeholder="Search Products"
            />
          </div>

          <div className="in-row-text-container-products">
            Manage Products
          </div>

          <div className="in-row-button-container">
            <Route
              render={({ history }) => {
                return (
                  <button
                    className="btn primary-green large"
                    onClick={() => history.push("/CreateProductLandingPage")}

                    title={TooltipCont.CREATE_PRODUCT}
                  >
                    Create New Product
                  </button>);
              }}
            />
          </div>
        </div>
        <table className="table-scrollable documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th>Product</th>
              <th>
                <FilterMenu
                  title="Type"
                  options={[
                    { title: "Bulletin" },
                    { title: "Quad Fold"},
                    { title: "Catalog"},
                  ]}
                  onFilter={(filterApplied: string) => {
                    this.shouldUpdate = true;
                    this.setState({ typesFilter: filterApplied });
                  }}
                  />
              </th>
              <th>
              <FilterMenu
                  title="Category"
                  options={categories.map((p) => {
                      return { title: p };
                    }
                  )}
                  onFilter={(filterApplied: string) => {
                    this.shouldUpdate = true;
                    this.setState({ categoryFilter: filterApplied });
                  }}
                  />
              </th>
              <th>
                <FilterMenu
                  title="Published/Unpublished"
                  options={[
                    { title: "Published" },
                    { title: "Unpublished"},
                  ]}
                  onFilter={(filterApplied: string) => {
                    this.shouldUpdate = true;
                    this.setState({ publishedFilter: filterApplied });
                  }}
                  />
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {filteredProducts.map((p, index, array) =>
              <tr key={p.id + '_' + p.type} ref={tr => this.tableRow = tr!}>
                <td dangerouslySetInnerHTML={{__html:p.name}} />
                <td>{p.type == "brochure" ? "Quad Fold" : p.type.charAt(0).toUpperCase() + p.type.slice(1)}</td>
                <td>{p.category.charAt(0).toUpperCase() + p.category.slice(1) }</td>
                <td>{p.published ? "Published" : "Unpublished"}</td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onEditProduct(p)}
                      title={TooltipCont.EDIT}
                      disabled={false}
                    >
                      Edit
                    </button>

                    <button
                      className="btn primary-blue"
                      onClick={() => this.props.onToggleProductPublish(p, !p.published)}
                      title={TooltipCont.PUBLISH}
                      disabled={false}
                    >
                      {p.published ? "Unpublish" : "Publish"}
                    </button>

                    
                  </div>
                  <div className="button-wrapper">

                    <button
                      className="btn primary-blue"
                      onClick={() => this.onPreviewProduct(p)}
                      title={TooltipCont.PREVIEW}
                      disabled={false}
                    >
                      Preview
                    </button>

                    <button
                        className="btn primary-red"
                        onClick={() => this.props.onDeleteProduct(p)}
                        title={TooltipCont.EDIT}
                        disabled={false}
                    >
                      Delete
                    </button>

                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ProductsTable.tsx